export * from '@/views/MovieDetailsView/RelatedMoviesView/RelatedMoviesView';
